import { OnEscapeListener } from '@carvana/merch-components';
import React, { useCallback, useContext } from 'react';
import FocusLock from 'react-focus-lock';
import Portal from '@/common/Portal';
import ModalContext from '~/context/srp/ModalContext';
import CloseIcon from '~/icons/Close';
import {
  DismissButton,
  Overlay,
  Modal,
  Header,
  Wrapper
} from './SaveSearchNudge.styles';

export default function SaveSearchNudgeModal({
  children
}: React.PropsWithChildren) {
  const { isSaveSearchNudgeOpen, setSaveSearchNudgeOpen } =
    useContext(ModalContext);

  const onToggle = useCallback(() => {
    setSaveSearchNudgeOpen(false);
  }, [setSaveSearchNudgeOpen]);

  return (
    <Portal id="save-search-nudge" open={isSaveSearchNudgeOpen}>
      <FocusLock autoFocus={false} group="modal">
        <OnEscapeListener onEscape={onToggle}>
          <Overlay />

          <Wrapper>
            <Modal>
              <Header>
                <DismissButton
                  onClick={onToggle}
                  data-analytics-id="Save Search Nudge - Dismiss"
                  data-qa="dismiss-nudge"
                >
                  <CloseIcon />
                </DismissButton>
              </Header>

              {children}
            </Modal>
          </Wrapper>
        </OnEscapeListener>
      </FocusLock>
    </Portal>
  );
}
